(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-contact-facility-type', {
                parent: 'entity',
                url: '/type-contact-facility-type',
                data: {
                    authorities: [],
                    pageTitle: 'TypeContactFacilityTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-contact-facility-type/list/type-contact-facility-type.html',
                        controller: 'TypeContactFacilityTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Contact Facility Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE, access);
                }]
            });
    }
})();
